"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatorPickerViewModel = calculatorPickerViewModel;
const published_1 = require("./published");
function calculatorPickerViewModel(district, items, calculators, buildHref, now) {
    return {
        title: district.title,
        cards: items.map((item) => {
            const calculator = calculators[item.key];
            const available = (0, published_1.isPublished)(calculator, now);
            return {
                key: item.key,
                title: calculator?.title ?? calculator?.shortTitle ?? item.key,
                description: calculator?.description,
                href: available ? buildHref(item.key) : undefined,
                available,
            };
        }),
    };
}
